
export const navigationLinks = [
  { text: "HOME", path: "/" },
  { text: "ABOUT ME", path: "/" },
  { text: "PROJECTS", path: "/" },
  { text: "MY SKILLS", path: "/" },
  { text: "SERVICES", path: "/" },
];



const transition = {
    duration: 0.6,
}
export const animatePageVariants = {
    initial: {
      opacity: 0,
      x:150,
    },
    animate: {
      opacity: 1,
      x: 0,
      transition
    },
    exit: {
      opacity: 0,
      x: '-100%',
      transition
    },
};


export const animateCardsVariants = {
  initial: {
    opacity: 0,
    x:50,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition
  },
  exit: {
    opacity: 0,
    x: 50,
    transition
  },
};


export const animateToTopVariants = {
  initial: {
    opacity: 0,
    y:50,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition
  },
  exit: {
    opacity: 0,
    y: 50,
    transition
  },
};


export const animateToLeftVariants = {
  initial: {
    opacity: 0,
    x:50,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition
  },
  exit: {
    opacity: 0,
    x: 50,
    transition
  },
};
export const animateToRightVariants = {
  initial: {
    opacity: 0,
    x:-50,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition
  },
  exit: {
    opacity: 0,
    x: -50,
    transition
  },
};